import { createBaseFormatterFactory } from './baseUtils.js';
/**
 * Format a number as octal.
 *
 * Syntax:
 *
 *    math.oct(value)
 *
 * Examples:
 *
 *    //the following outputs "0o70"
 *    math.oct(56)
 *
 * See also:
 *
 *    bin
 *    hex
 *
 * @param {number} value  Value to be stringified
 * @return {string}       The formatted value
 */

export var createOct = createBaseFormatterFactory('oct', 8);


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/function/string/oct.js
// module id = null
// module chunks = 